import { useState } from "react";
import { ContentWrapper } from "../../_common";
import SelectContract from "../../_common/SelectContract";
import { useQueryClient } from "react-query";
import { SelectDocType } from "./СonnectionDocuments.styled";
import DownloadDoc from "./DownloadDoc";

const СonnectionDocuments = () => {
  const {
    contracts,
    contractAisId,
    docConnection,
    contractId,
    changeContract,
    changeDocConnection,
  } = useConnection();

  return (
    <ContentWrapper>
      <SelectContract
        changeContract={changeContract}
        contracts={contracts}
        value={contractAisId}
      />
      {contractAisId ? (
        <SelectDocType
          placeholder="Выберите тип документа"
          onChange={changeDocConnection}
          options={[
            { value: "1", label: "Проект договора энергоснабжения" },
            { value: "2", label: "Дополнительное соглашение" },
            { value: "3", label: "Акт о тех.присоединении" },
            { value: "4", label: "Акт допуска ПУ в эксплуатацию" },
          ]}
          dropdownMatchSelectWidth={false}
        />
      ) : null}
      {docConnection ? (
        <DownloadDoc docConnection={docConnection} contractId={contractId} />
      ) : null}
    </ContentWrapper>
  );
};

function useConnection() {
  const queryClient = useQueryClient();
  const contracts = queryClient.getQueryData<Models.Contract[]>("contracts");
  const [contractAisId, setContractAisId] = useState<number>(null);
  const [docConnection, setDocConnection] = useState(null);
  const contractId = contracts.find((i) => i.id === contractAisId);

  const changeContract = (value) => {
    setContractAisId(value);
  };

  const changeDocConnection = (value) => {
    setDocConnection(value);
  };

  return {
    contracts,
    contractAisId,
    changeContract,
    changeDocConnection,
    docConnection,
    contractId: contractId?.aisId,
  };
}

export default СonnectionDocuments;
